export default __webpack_public_path__ + "static/media/Suites-RGB.1af33d58.webp";